import React from "react";
import { Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "./TextDecrypt";
import Resume from "../../settings/resume.json";
import { FirstName, LastName } from "../../utils/getName";
import { Typewriter } from 'react-simple-typewriter'

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: "auto",
    marginBottom: "auto",
  },
  heading: {
    marginLeft: theme.spacing(50),
    "@media (max-width: 768px)": {
      marginLeft: theme.spacing(10),
    },
  },
  jobs: {
    "@media (max-width: 768px)": {
      fontSize: '3rem',
    },
  },
}));

export const Content = () => {
  const classes = useStyles()
  
  const handleType = (count) => {
    // access word count number
    
  }

  const handleDone = () => {
    
  }

  return (
    <Container component="main" className={classes.main} maxWidth="md">
      <div className={classes.heading}>
        <Typography variant="h5" component="h2">
          
            <TextDecrypt text={`${FirstName} ${LastName}`} />
        </Typography>
        <Typography variant="h1" component="h1" className={classes.jobs}>
            <TextDecrypt text={`${Resume.basics.name}`} />
            
            <h5>
        A{' '} 
        <span>
          {/* Style will be inherited from the parent element */}
          <Typewriter
            words={['MERN Stack', 'Full Stack', 'React', 'Front-End',]}
            loop={8}
            cursor
            cursorStyle='|'
            typeSpeed={70}
            deleteSpeed={60}
            delaySpeed={1500}
            onLoopDone={handleDone}
            onType={handleType}
          />
        </span>Developer
      </h5>

        </Typography>
      </div>
    </Container>
  );
};
